/* eslint-disable prettier/prettier */
// src/modules/owner/pages/actions/tanqueCheio/sections/information.jsx
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MaterialGrid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import PrimaryButton from 'common/components/buttons/primaryButton';
import GenericConfirmationCard from 'common/components/cards/genericConfirmationModel/genericConfirmationModel';
import NewSelectMultiple from 'common/components/fields/NewSelectMultiple';
import { InputLabelOutlined } from 'common/components/fields/InputLabelOutlined';
import { InputEasyImageWithProcessing } from 'common/components/fields/InputEasyImageWithProcessing';
import { EditorConvertToHTMLActivity } from 'common/components/fields/EditorConvertToHTMLActivity';
import UploadVideos from 'common/components/upload';
import { FORM_RULES } from 'helpers/validations';
import _ from 'lodash';
import axios from 'axios';
import { BASE_API, USER_TOKEN } from 'config/consts';
import { requiredFieldError, uploadImageFileToS3 } from 'modules/owner/pages/actions/actionsFile';
import StationImageModal from '../components/StationImageModal';
import ImageCropModal from '../components/ImageCropModal';
import ImageOptionsModal from '../components/ImageOptionsModal';
import { getList as getCategoriesList } from '../../../categories/categoriesActions';
import { getGroupingsStationId, getGroupingsMultipleStations } from './../../groupings/groupingsActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm, getFormValues, getFormSyncErrors } from 'redux-form';
import { isMobile } from 'react-device-detect';
import { styled } from '@mui/material/styles';


export const ImagePreviewContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'imagePath',
})(({ imagePath, theme }) => ({
  width: '100%',
  paddingTop: `${(9 / 16) * 100}%`,
  position: 'relative',
  backgroundImage: imagePath ? `url(${imagePath})` : 'none',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  border: '1px dashed rgba(0,0,0,0.23)',
  borderRadius: theme.shape.borderRadius,
  display: imagePath ? 'block' : 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:before': !imagePath
    ? {
        content: `"📷"`,
        fontSize: 24,
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: 'rgba(0,0,0,0.3)',
      }
    : {},
}));

class Information extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSelectedStation: null,
      stationImages: {},
      stationImageFiles: {},
      showModal: false,
      modalImage: null,
      selectedStationsFromForm: [],
      processedStations: new Set(),
      showStationImageModal: false,
      currentStationForImage: null,
      stationImageQueue: [],
      submitted: false,
      poppedUp: false,
      showCropModal: false,
      cropImageSrc: null,
      cropStationData: null,
      showOptionsModal: false,
      optionsStationData: null,
      stationCategories: {}, // { stationId: [categories] }
      loadingCategories: false,
    };
    const stationId = this.props.auth.user.establishments[0].stations[0].id;
    this.props.getCategoriesList(stationId);
    
    const allUserStationIds = [];
    const stationsMap = {};
    this.props.auth.user.establishments.forEach((est) => {
      if (est.stations && Array.isArray(est.stations)) {
        est.stations.forEach((s) => {
          if (!allUserStationIds.includes(s.id)) {
            allUserStationIds.push(s.id);
            stationsMap[s.id] = s.name || '';
          }
        });
      }
    });
    this.props.getGroupingsMultipleStations(allUserStationIds, stationsMap);
  }

  componentDidMount() {
    this.fetchStations();
    
    // Restaurar station_images do Redux Form se existir
    if (this.props.formValues?.station_images && Object.keys(this.props.formValues.station_images).length > 0) {
      this.setState({ stationImages: this.props.formValues.station_images });
    } else if (this.props.formValues?.image) {
      // Fallback: reconstruir station_images a partir da image + station_id
      const stationId = this.props.formValues.station_id;
      const stations = this.props.formValues.stations_field || [];
      if (stationId) {
        this.setState({ stationImages: { [stationId]: this.props.formValues.image } });
      } else if (stations.length > 0) {
        this.setState({ stationImages: { [stations[0].id]: this.props.formValues.image } });
      }
    }
  }

  fetchStations = async () => {
    try {
      const response = await axios.get(`${BASE_API}/stations`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      });
      this.setState({ stations: response.data || [] });
    } catch (error) {
      console.error('Erro ao buscar estações:', error);
    }
  };

  // Buscar categorias de uma station específica
  fetchCategoriesForStation = async (stationId) => {
    if (this.state.stationCategories[stationId]) return; // Já carregado
    try {
      const response = await axios.get(`${BASE_API}/categories`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
        params: { 
          'where[station_id]': stationId 
        }
      });
      this.setState(prev => ({
        stationCategories: {
          ...prev.stationCategories,
          [stationId]: response.data || []
        }
      }));
    } catch (error) {
      console.error('Erro ao buscar categorias da station:', error);
    }
  };

  // Buscar categorias de todas as stations selecionadas
  fetchCategoriesForSelectedStations = async (selectedStations) => {
    if (!selectedStations || selectedStations.length === 0) return;
    this.setState({ loadingCategories: true });
    await Promise.all(
      selectedStations.map(station => this.fetchCategoriesForStation(station.id))
    );
    this.setState({ loadingCategories: false });
  };

  onSubmit = (values) => {
    if (values.categories_field) {
      values.categories = values.categories_field.map((item) => item.id);
    }
    if (values.groupings_field) {
      values.groupings = values.groupings_field.map((item) => item.id);
    }
    
    const selectedStations = values.stations_field || [];
    if (selectedStations.length > 0) {
      const missingImages = selectedStations.filter(station => 
        !this.state.stationImages[station.id]
      );
      
      if (missingImages.length > 0) {
        this.props.openSnackbar({
          message: `Por favor, selecione imagens para as seguintes estações: ${missingImages.map(s => s.title || s.name).join(', ')}`,
          variant: 'warning',
          open: true,
        });
        return; 
      }
    }
    
    values.submitFromButton = true;
    
    // SALVAR station_images no Redux Form para o publish.jsx usar
    if (this.state.stationImages && Object.keys(this.state.stationImages).length > 0) {
      this.props.change('station_images', this.state.stationImages);
      values.station_images = this.state.stationImages;
      console.log('✅ Salvando station_images no Redux Form:', this.state.stationImages);
    } else {
      this.props.change('station_images', null);
      values.station_images = null;
      console.log('❌ Nenhuma station_images para salvar');
    }
    
    if (this.state.stationImages && Object.keys(this.state.stationImages).length > 0) {
      const firstStationImagePath = Object.values(this.state.stationImages)[0];
      
      const fullImageUrl = `https://s3.amazonaws.com/rilato.app.files/${firstStationImagePath}`;

      values.image = firstStationImagePath;
      values.image_id = firstStationImagePath;
      values.primaryImageId = firstStationImagePath;

      this.props.change('image', firstStationImagePath);
    } else {
      console.log('❌ NENHUMA IMAGEM ENCONTRADA!');
    }

    if (this.props.handleNativeChange) {
      const currentValue = this.props.value || 0;
      const nextValue = currentValue + 1;
      this.props.handleNativeChange(null, nextValue);
    }
  };

  handleStationClick = (station) => {
    // Se a station já tem imagem, abre modal de opções
    if (this.state.stationImages[station.id]) {
      this.setState({
        showOptionsModal: true,
        optionsStationData: station
      });
    } else {
      // Se não tem imagem, abre seletor de arquivo
      this.setState({ currentSelectedStation: station });
      const input = document.getElementById('station-image-input');
      if (input) {
        input.click();
      }
    }
  };

  handleStationImageChange = async (event) => {
    const file = event.target.files[0];
    const { currentSelectedStation } = this.state;
    
    if (file && currentSelectedStation) {
      // Após selecionar arquivo, abrir modal de crop ANTES do upload
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        this.setState({
          showCropModal: true,
          cropImageSrc: reader.result,
          cropStationData: currentSelectedStation
        });
      });
      reader.readAsDataURL(file);
    }
  };

  handleCropComplete = async (imageId, file, croppedImageBase64) => {
    const { cropStationData } = this.state;
    
    console.log('handleCropComplete chamado:', { imageId, cropStationData });
    
    if (cropStationData && imageId) {
      try {
        const newStationImages = {
          ...this.state.stationImages,
          [cropStationData.id]: imageId
        };
        
        console.log('Atualizando stationImages:', newStationImages);
        
        this.setState({
          stationImages: newStationImages,
          stationImageFiles: {
            ...this.state.stationImageFiles,
            [cropStationData.id]: file
          },
          showCropModal: false,
          cropImageSrc: null,
          cropStationData: null,
          currentSelectedStation: cropStationData
        });
        
        this.props.change('image', imageId);
        
        this.props.openSnackbar({
          message: 'Imagem processada e salva com sucesso!',
          variant: 'success',
          open: true,
        });
        
      } catch (error) {
        console.error('Erro ao processar imagem:', error);
        this.props.openSnackbar({
          message: 'Erro ao processar a imagem. Tente novamente.',
          variant: 'error',
          open: true,
        });
      }
    }
  };

  handleCloseCropModal = () => {
    this.setState({
      showCropModal: false,
      cropImageSrc: null,
      cropStationData: null
    });
  };

  handleCloseOptionsModal = () => {
    this.setState({
      showOptionsModal: false,
      optionsStationData: null
    });
  };

  handleSubstituirImagem = () => {
    const { optionsStationData } = this.state;
    if (optionsStationData) {
      this.setState({ 
        currentSelectedStation: optionsStationData,
        showOptionsModal: false,
        optionsStationData: null
      });
      
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';
      input.onchange = (event) => {
        const file = event.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.addEventListener('load', () => {
            this.setState({
              showCropModal: true,
              cropImageSrc: reader.result,
              cropStationData: optionsStationData
            });
          });
          reader.readAsDataURL(file);
        }
      };
      input.click();
    }
  };

  handleRemoverImagem = () => {
    const { optionsStationData } = this.state;
    if (optionsStationData) {
      const newStationImages = { ...this.state.stationImages };
      const newStationImageFiles = { ...this.state.stationImageFiles };
      
      delete newStationImages[optionsStationData.id];
      delete newStationImageFiles[optionsStationData.id];
      
      this.setState({
        stationImages: newStationImages,
        stationImageFiles: newStationImageFiles,
        showOptionsModal: false,
        optionsStationData: null
      });

      this.props.openSnackbar({
        message: 'Imagem removida com sucesso!',
        variant: 'success',
        open: true,
      });
    }
  };

  handleVerImagem = () => {
    const { optionsStationData } = this.state;
    if (optionsStationData && this.state.stationImages[optionsStationData.id]) {
      const stationImageId = this.state.stationImages[optionsStationData.id];
      
      this.setState({
        currentSelectedStation: optionsStationData,
        showOptionsModal: false,
        optionsStationData: null
      });
      
      this.props.change('image', stationImageId);
    }
  };

  renderStationSelector = () => {
    const selectedStations = this.props.formValues?.stations_field || [];
    
    const hasSelectedStations = Array.isArray(selectedStations) && selectedStations.length > 0;
    
    if (!hasSelectedStations) {
      return (
        <div style={{ marginTop: 20, marginBottom: 16 }}>
          <Typography
            variant="subtitle2"
            style={{
              fontSize: 14,
              fontWeight: 500,
              marginBottom: 12,
              color: '#666'
            }}
          >
            Selecione stations acima para fazer upload das imagens
          </Typography>
        </div>
      );
    }
    
    return (
      <div style={{ marginTop: 20, marginBottom: 16 }}>
        <Typography
          variant="subtitle2"
          style={{
            fontSize: 14,
            fontWeight: 500,
            marginBottom: 12,
            color: '#666'
          }}
        >
          Clique em uma station para fazer upload da imagem:
        </Typography>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          {selectedStations.map((station, index) => {
            const hasImage = this.state.stationImages[station.id];
            return (
              <div
                key={station.id || index}
                onClick={() => this.handleStationClick(station)}
                style={{
                  padding: '8px 16px',
                  backgroundColor: hasImage ? '#e8f5e8' : '#f5f5f5',
                  border: `2px solid ${hasImage ? '#4caf50' : '#ddd'}`,
                  borderRadius: 20,
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 6,
                  fontSize: 14,
                  fontWeight: 500,
                  color: hasImage ? '#2e7d32' : '#666',
                  position: 'relative'
                }}
                onMouseEnter={(e) => {
                  const target = e.currentTarget;
                  target.style.transform = 'translateY(-1px)';
                  target.style.boxShadow = hasImage ? '0 4px 8px rgba(76, 175, 80, 0.3)' : '0 4px 8px rgba(0, 0, 0, 0.1)';
                }}
                onMouseLeave={(e) => {
                  const target = e.currentTarget;
                  target.style.transform = 'translateY(0)';
                  target.style.boxShadow = 'none';
                }}
              >
                {hasImage && (
                  <span style={{ 
                    color: '#4caf50', 
                    fontSize: '16px',
                    fontWeight: 'bold'
                  }}>✓</span>
                )}
                {station.title || station.name || `Station ${station.id}`}
              </div>
            );
          })}
        </div>
        <input
          type="file"
          accept="image/*"
          style={{ display: 'none' }}
          id="station-image-input"
          onChange={this.handleStationImageChange}
        />
      </div>
    );
  };


  componentDidUpdate(prev) {
    if (
      !_.isEmpty(this.props.submitErrors) &&
      this.state.submitted &&
      !this.state.poppedUp
    ) {
      this.props.requiredFieldError();
      this.setState({ poppedUp: true, submitted: false });
    }
    if (this.props.submitErrors !== prev.submitErrors && this.state.poppedUp) {
      this.setState({ poppedUp: false });
    }
    // Restaurar stationImages quando formValues é inicializado (edição)
    if (
      this.props.formValues?.image &&
      !prev.formValues?.image &&
      Object.keys(this.state.stationImages).length === 0
    ) {
      const si = this.props.formValues.station_images;
      if (si && Object.keys(si).length > 0) {
        this.setState({ stationImages: si });
      } else {
        const sid = this.props.formValues.station_id;
        const stations = this.props.formValues.stations_field || [];
        if (sid) {
          this.setState({ stationImages: { [sid]: this.props.formValues.image } });
        } else if (stations.length > 0) {
          this.setState({ stationImages: { [stations[0].id]: this.props.formValues.image } });
        }
      }
    }
  }

  render() {
    const {
      auth,
      categories,
      groupings,
      formValues,
      handleSubmit,
      openConfirmation,
      handleCancelClose,
      confirmationTitle,
      confirmationSubtitle,
      buttonConfirmationLabel,
      setOpenConfirmation,
      closeModal,
      general,
      activeActions,
      goBack,
    } = this.props;

    const atividade = formValues || {};
    const now = new Date();
    const isDisabled = atividade.is_tanque_cheio ? false : (!atividade.is_draft && now > new Date(atividade.end));

    const stationsById = (this.state.stations || []).reduce((acc, s) => {
      acc[s.id] = s;
      return acc;
    }, {});

    const categoriesList = (categories.list.content || []).map((c) => ({
      id: c.id,
      title: c.name,
    }));
    const groupingsList = (groupings || []).map((g) => {
      const stationName = g.stationName || stationsById[g.station_id]?.name || g.station?.name || '';
      return {
        id: g.id,
        title: stationName ? `${g.name} (${stationName})` : g.name,
      };
    });

    return (
      <>
        <form onSubmit={handleSubmit(this.onSubmit)} noValidate>
          <div
            style={{
              overflowY: 'auto',
              height: isMobile
                ? 'calc(100vh - 240px)'
                : 'calc(100vh - 355px)',
              padding: '0 16px',
            }}
          >
            {/* 1. Título */}
            <Typography
              variant="subtitle2"
              style={{
                fontSize: 16,
                fontWeight: 400,
                marginTop: 16,
              }}
            >
              Título
            </Typography>
            <MaterialGrid item xs={12}>
              <Field
                component={InputLabelOutlined}
                name="name"
                label="Nome dessa atividade"
                validate={[FORM_RULES.required, FORM_RULES.maxL(60)]}
                disabled={isDisabled}
              />
            </MaterialGrid>

            {/* 2. Publicar nas Stations */}
            <Typography
              variant="subtitle2"
              style={{
                fontSize: 16,
                fontWeight: 400,
                marginTop: 20,
              }}
            >
              Publicar nas Stations
            </Typography>
            <MaterialGrid container spacing={2}>
              <MaterialGrid item xs={12}>
                <Field
                  component={NewSelectMultiple}
                  label="Selecione as Stations"
                  options={(this.state.stations || []).map((station) => ({
                    id: station.id,
                    title: station.name,
                  }))}
                  name="stations_field"
                  disabled={isDisabled}
                  onChange={(e, newValue) => {
                    this.fetchCategoriesForSelectedStations(newValue);
                  }}
                />
              </MaterialGrid>
            </MaterialGrid>

            {/* 3. Categoria - mostrando qual station cada categoria pertence */}
            <Typography
              variant="subtitle2"
              style={{
                fontSize: 16,
                fontWeight: 400,
                marginTop: 20,
              }}
            >
              Categoria
            </Typography>
            <MaterialGrid container spacing={2}>
              <MaterialGrid item xs={12}>
                <Field
                  component={NewSelectMultiple}
                  name="categories_field"
                  options={(() => {
                    const selectedStations = formValues?.stations_field || [];
                    if (selectedStations.length === 0) {
                      return categoriesList;
                    }
                    // Criar lista de categorias com nome da station
                    const categoriesWithStation = [];
                    selectedStations.forEach(station => {
                      const stationCats = this.state.stationCategories[station.id] || [];
                      stationCats.forEach(cat => {
                        categoriesWithStation.push({
                          id: cat.id,
                          title: `${cat.name} (${station.title || station.name})`,
                          stationId: station.id,
                          stationName: station.title || station.name,
                        });
                      });
                    });
                    return categoriesWithStation.length > 0 ? categoriesWithStation : categoriesList;
                  })()}
                  disabled={isDisabled}
                />
              </MaterialGrid>
            </MaterialGrid>

            {/* 4. Agrupamento */}
            <Typography
              variant="subtitle2"
              style={{
                fontSize: 16,
                fontWeight: 400,
                marginTop: 20,
              }}
            >
              Agrupamento
            </Typography>
            <MaterialGrid container spacing={2}>
              <MaterialGrid item xs={12}>
                <Field
                  component={NewSelectMultiple}
                  name="groupings_field"
                  options={groupingsList}
                  disabled={isDisabled}
                />
              </MaterialGrid>
            </MaterialGrid>

            {/* Seletor de Stations para Upload */}
            {this.renderStationSelector()}

            {/* Área de Preview da Imagem */}
            <Typography
              variant="subtitle2"
              style={{
                fontSize: 16,
                fontWeight: 400,
                marginTop: 20,
              }}
            >
              {formValues && formValues.stations_field && formValues.stations_field.length > 0 
                ? 'Preview da Imagem' 
                : 'Imagens'}
            </Typography>
            <MaterialGrid item xs={12}>
              {formValues && formValues.stations_field && formValues.stations_field.length > 0 ? (
                <div
                  style={{
                    border: '2px dashed #ddd',
                    borderRadius: 8,
                    padding: 32,
                    textAlign: 'center',
                    backgroundColor: '#fafafa',
                    minHeight: 200,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {(() => {
                    // Determinar qual station mostrar: a selecionada ou a primeira que tem imagem
                    const displayStation = this.state.currentSelectedStation 
                      || (formValues.stations_field || []).find(s => this.state.stationImages[s.id]);
                    const hasImage = displayStation && (
                      this.state.stationImageFiles[displayStation.id] || this.state.stationImages[displayStation.id]
                    );
                    
                    if (hasImage) {
                      return (
                        <div>
                          <Typography variant="subtitle2" style={{ marginBottom: 16, fontWeight: 600 }}>
                            {displayStation.title || displayStation.name}
                          </Typography>
                          <img
                            src={
                              this.state.stationImageFiles[displayStation.id] 
                                ? URL.createObjectURL(this.state.stationImageFiles[displayStation.id])
                                : `https://s3.amazonaws.com/rilato.app.files/${this.state.stationImages[displayStation.id]}`
                            }
                            alt={`Preview ${displayStation.title || displayStation.name}`}
                            style={{
                              maxWidth: '100%',
                              maxHeight: 300,
                              objectFit: 'contain',
                              borderRadius: 8,
                              boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                            }}
                          />
                        </div>
                      );
                    }
                    return (
                      <div>
                        <div style={{ fontSize: 64, color: '#ccc', marginBottom: 16 }}>🖼️</div>
                        <Typography variant="body2" color="textSecondary">
                          {formValues.stations_field.length > 0 
                            ? 'Clique em uma station acima para fazer upload da imagem'
                            : 'Selecione stations para fazer upload das imagens'}
                        </Typography>
                      </div>
                    );
                  })()}
                </div>
              ) : (
                <Field
                  component={InputEasyImageWithProcessing}
                  name="image"
                  aspect={16 / 9}
                  aspectLabel="16:9"
                  validate={[FORM_RULES.required]}
                  disabled={isDisabled}
                />
              )}
            </MaterialGrid>

            <Typography
              variant="subtitle2"
              style={{
                fontSize: 16,
                fontWeight: 400,
                marginTop: 20,
              }}
            >
              Texto do botão
            </Typography>
            <MaterialGrid item xs={12}>
              <Field
                component={InputLabelOutlined}
                name="click_me_label"
                label="Label do card (Ex: Participe)"
                validate={[FORM_RULES.required]}
                disabled={isDisabled}
              />
            </MaterialGrid>

            <Typography
              variant="subtitle2"
              style={{
                fontSize: 16,
                fontWeight: 400,
                marginTop: 20,
              }}
            >
              Conteúdo da postagem
            </Typography>
            <MaterialGrid item xs={12}>
              <Field
                component={EditorConvertToHTMLActivity}
                name="description"
                imageRatio="none"
                disabled={isDisabled}
              />
            </MaterialGrid>

            <Typography
              variant="subtitle2"
              style={{
                fontSize: 16,
                fontWeight: 400,
                marginTop: 20,
              }}
            >
              Selecionar/Upload Vídeo(s)
            </Typography>
            <MaterialGrid item xs={12}>
              <Field
                component={UploadVideos}
                indexVideo={0}
                multipleVideos={false}
                formValues={formValues}
                name="videoIdField"
                disabled={isDisabled}
              />
            </MaterialGrid>
          </div>

          <MaterialGrid
            container
            spacing={2}
            sx={{ mt: 5, px: 2, pb: 2 }}
          >
            <MaterialGrid item xs={6}>
              <PrimaryButton
                type="button"
                color="secondary"
                onClick={goBack}
                disabled
                fullWidth
              >
                Voltar
              </PrimaryButton>
            </MaterialGrid>
            <MaterialGrid item xs={6}>
              <PrimaryButton
                type="submit"
                color="primary"
                onClick={() =>
                  this.setState({ submitted: true })
                }
                disabled={
                  activeActions.buttonLoading || isDisabled
                }
                fullWidth
              >
                Salvar e continuar
              </PrimaryButton>
            </MaterialGrid>
          </MaterialGrid>
        </form>

        <GenericConfirmationCard
          open={openConfirmation}
          cancelClose={handleCancelClose}
          labelLeftButton="Continuar aqui"
          labelRightButton={buttonConfirmationLabel || "Sim, sair da edição"}
          title={confirmationTitle || "Deseja sair da edição?"}
          text={confirmationSubtitle || "Lembre-se, as informações que não foram salvas serão perdidas."}
          general={general}
          maxWidthFixed
          confirmButtonColor="primary"
          onClose={handleCancelClose}
          onClick={closeModal}
        />

        {/* Modal de Crop de Imagem */}
        <ImageCropModal
          open={this.state.showCropModal}
          onClose={this.handleCloseCropModal}
          imageSrc={this.state.cropImageSrc}
          onCropComplete={this.handleCropComplete}
          stationName={this.state.cropStationData?.title || this.state.cropStationData?.name}
          aspect={16/9}
          aspectLabel="16:9"
        />

        {/* Modal de Opções de Imagem */}
        <ImageOptionsModal
          open={this.state.showOptionsModal}
          onClose={this.handleCloseOptionsModal}
          stationName={this.state.optionsStationData?.title || this.state.optionsStationData?.name}
          onSubstituir={this.handleSubstituirImagem}
          onRemover={this.handleRemoverImagem}
          onVer={this.handleVerImagem}
        />
      </>
    );
  }
}

Information.propTypes = {
  auth: PropTypes.object.isRequired,
  categories: PropTypes.object.isRequired,
  groupings: PropTypes.array.isRequired,
  formValues: PropTypes.object,
  activeActions: PropTypes.object,
  general: PropTypes.object,
  openConfirmation: PropTypes.bool,
  handleCancelClose: PropTypes.func,
  setOpenConfirmation: PropTypes.func,
  confirmationTitle: PropTypes.string,
  confirmationSubtitle: PropTypes.string,
  buttonConfirmationLabel: PropTypes.string,
  closeModal: PropTypes.func,
  goBack: PropTypes.func,
  onClickProgress: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  categories: state.categories,
  groupings: state.groupings.list,
  activeActions: state.activeActions,
  general: state.general,
  formValues: getFormValues('tanqueCheioForm')(state),
  submitErrors: getFormSyncErrors('tanqueCheioForm')(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getCategoriesList,
      getGroupingsStationId,
      getGroupingsMultipleStations,
      requiredFieldError,
      openSnackbar: (payload) => ({ type: 'SNACKBAR', payload }),
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: 'tanqueCheioForm',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  })(Information)
);
